/**
 * Matches URLs that mint/fetch a token rather than perform a real action (e.g. the Nick Fury
 * backend's firebase-token call). Shared by
 * request-log.interceptor.ts and notifications.interceptor.ts so neither the audit log nor the
 * notifications drawer surfaces this internal auth plumbing as if it were a real request a user
 * made.
 */
export function isTokenRequest(url: string): boolean {
  let pathname = url;
  try {
    pathname = new URL(url, window.location.origin).pathname;
  } catch {
    // Keep the raw url — still useful for the regex test below.
  }
  return /token/i.test(pathname);
}
